export default "__VITE_ASSET__jKNxsC3k__"